"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const caunter_1 = __importDefault(require("./caunter"));
const createButtonStillLamps_1 = __importDefault(require("../lampModules/createButtonStillLamps"));
const createButtonStillLamps_2 = require("../lampModules/createButtonStillLamps");
const data_start_1 = require("../../data-start");
const showElementNotProduct_1 = __importDefault(require("../lampModules/showElementNotProduct"));
const showImg_1 = require("../lampModules/showImg");
//= createLampElement 
const createLampElement = (currentArrLamps, startNumberElement, finishNumberElement) => {
    const lampsBlock = document.querySelector('#box-for-lamp');
    const path = window.location.pathname;
    if (currentArrLamps.length < 13) {
        (0, createButtonStillLamps_1.default)(createButtonStillLamps_2.ComandButtonLamp.Delete);
    }
    if (currentArrLamps.length === 0) {
        (0, showElementNotProduct_1.default)('show');
    }
    else {
        (0, showElementNotProduct_1.default)('hidden');
    }
    for (let i = startNumberElement; i < finishNumberElement; i++) {
        let obj = currentArrLamps[i];
        if (obj) {
            pathLamps(path, lampsBlock, data_start_1.priceUP, obj);
        }
        else {
            (0, createButtonStillLamps_1.default)(createButtonStillLamps_2.ComandButtonLamp.Delete);
            (0, caunter_1.default)('zero');
            break;
        }
    }
};
exports.default = createLampElement;
//: добавление карточки товара в зависимости от страницы на которой находится клиент 
function pathLamps(path, body, priceUP, obj) {
    if (path.split('.')[1] !== 'html') {
        path += '.html';
    }
    console.log('', path);
    const componentsLamp = {
        '/lamps-panel.html': (element) => {
            element.insertAdjacentHTML('beforeend', `
                <div class="cart-lamp__body">
                    <div class="cart-lamp__img">
                        <img src="${obj.img}" alt="lamps">
                    </div>
                    <div class="cart-lamp__info">
                        <div class="cart-lamp__title">${obj.title}</div>
                        <div class="cart-lamp__article">Артикул: ${obj.article}</div>
                        <div class="text-lamp"><span>Мощность</span>: ${obj.wats}W</div>
                        <div class="text-lamp"><span>Размер</span>: ${obj.diameter}mm</div>
                        <div class="text-lamp"><span>Врезное отверстие</span>: ${obj.diameterCut}mm</div>
                        <div class="text-lamp"><span>Цвет свечения</span>: ${obj.colorLightK}K</div>
                        <div class="text-lamp"><span>Световой поток</span>: ${obj.lightStream}Lm</div>
                        <div class="cart-lamp__price"><span>${(+obj.price * priceUP).toFixed(2)} BYN</span></div>
                    </div>
                </div>
            `);
        },
        '/lamps-trek.html': (element) => {
            element.insertAdjacentHTML('beforeend', `
                <div class="cart-lamp__body">
                    <div class="cart-lamp__img">
                        <img src="${obj.img}" alt="lamps">
                    </div>
                    <div class="cart-lamp__info">
                        <div class="cart-lamp__title">${obj.title}</div>
                        <div class="cart-lamp__article">Артикул: ${obj.article}</div>

                        <div class="text-lamp"><span>Мощность</span>: ${obj.wats}</div>
                        <div class="text-lamp"><span>Размер</span>: ${obj.diameter}</div>
                        <div class="text-lamp"><span>Вращение</span>: ${obj.rotation}</div>
                        <div class="text-lamp"><span>Патрон</span>: ${obj.patron}</div>
                        <div class="text-lamp"><span>Материал</span>: ${obj.material}</div>

                        <div class="cart-lamp__price"><span>${(+obj.price * priceUP).toFixed(2)} BYN</span></div>
                    </div>
                </div>
            `);
        },
        '/lamps-lustre.html': (element) => {
            element.insertAdjacentHTML('beforeend', `
                <div class="cart-lamp__body">
                    <div class="cart-lamp__img">
                        <img src="${obj.img}" alt="lamps">
                    </div>
                    <div class="cart-lamp__info">
                        <div class="cart-lamp__title">${obj.title}</div>
                        <div class="cart-lamp__article">Артикул: ${obj.article}</div>
                        <div class="text-lamp"><span>Цвет</span>: ${obj.color}</div>
                        <div class="text-lamp"><span>Размер плафона</span>: ${obj.diameter}mm</div>
                        <div class="text-lamp"><span>Размер основания</span>: ${obj.diameterCut}mm</div>
                        <div class="text-lamp"><span>Патрон</span>: ${obj.patron}</div>
                        <div class="text-lamp"><span>Материал</span>: ${obj.material}</div>
                        <div class="cart-lamp__price"><span>${(+obj.price * priceUP).toFixed(2)} BYN</span></div>
                    </div>
                </div>
            `);
        },
        '/lamps-dot.html': (element) => {
            element.insertAdjacentHTML('beforeend', `
                <div class="cart-lamp__body">
                    <div class="cart-lamp__img">
                        <img src="${obj.img}" alt="lamps">
                    </div>
                    <div class="cart-lamp__info">
                        <div class="cart-lamp__title">${obj.title}</div>
                        <div class="cart-lamp__article">Артикул: ${obj.article}</div>

                        <div class="text-lamp"><span>Цвет</span>: ${obj.color}</div>
                        <div class="text-lamp"><span>Размер</span>: ${obj.diameter}</div>
                        <div class="text-lamp"><span>Врезное отверстие</span>: ${obj.diameterCut}</div>
                        <div class="text-lamp"><span>Цоколь</span>: ${obj.patron}</div>
                        <div class="text-lamp"><span>Цвет подсветки</span>: ${obj.colorLightK}</div>

                        <div class="cart-lamp__price"><span>${(+obj.price * priceUP).toFixed(2)} BYN</span></div>
                    </div>
                </div>
            `);
        },
        '/lamps-light.html': (element) => {
            element.insertAdjacentHTML('beforeend', `
                <div class="cart-lamp__body">
                    <div class="cart-lamp__img">
                        <img src="${obj.img}" alt="lamps">
                    </div>
                    <div class="cart-lamp__info">
                        <div class="cart-lamp__title">${obj.title}</div>
                        <div class="cart-lamp__article">Артикул: ${obj.article}</div>
                        <div class="text-lamp"><span>Серия</span>: ${obj.material}</div>
                        <div class="text-lamp"><span>Мощность</span>: ${obj.wats}</div>
                        <div class="text-lamp"><span>Световой поток</span>: ${obj.lightStream}</div>
                        <div class="text-lamp"><span>Цвет свечения</span>: ${obj.colorLightK}</div>
                        <div class="text-lamp"><span>Размер</span>: ${obj.diameter}</div>
                        <div class="text-lamp"><span>Пульт</span>: ${obj.patron}</div>
                        <div class="cart-lamp__price"><span>${(+obj.price * priceUP).toFixed(2)} BYN</span></div>
                    </div>
                </div>
            `);
        },
        '/lamps-spot.html': (element) => {
            element.insertAdjacentHTML('beforeend', `
                <div class="cart-lamp__body">
                    <div class="cart-lamp__img">
                        <img src="${obj.img}" alt="lamps">
                    </div>
                    <div class="cart-lamp__info">
                        <div class="cart-lamp__title">${obj.title}</div>
                        <div class="cart-lamp__article">Артикул: ${obj.article}</div>
                        <div class="text-lamp"><span>Цвет</span>: ${obj.color}</div>
                        <div class="text-lamp"><span>Размер</span>: ${obj.diameter}mm</div>
                        <div class="text-lamp"><span>Патрон</span>: ${obj.patron}</div>
                        <div class="text-lamp"><span>Вращение</span>: ${obj.rotation}</div>
                        <div class="text-lamp"><span>Материал</span>: ${obj.material}</div>

                        <div class="cart-lamp__price"><span>${(+obj.price * priceUP).toFixed(2)} BYN</span></div>
                    </div>
                </div>
            `);
        },
    };
    const element = document.createElement('div');
    element.classList.add('cart-lamp');
    const functionComponentsLamp = componentsLamp[path];
    if (functionComponentsLamp) {
        functionComponentsLamp(element);
        (0, showImg_1.addEventListenerForElement)(element);
        body.append(element);
    }
}
